export default function WhyTrainingsFail() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  const badModel = [
    { label: 'Тренинг', desc: 'Стандартная программа, не адаптированная под задачи бизнеса' },
    { label: 'Воодушевление', desc: 'Участники замотивированы, но не знают, как применить знания' },
    { label: 'Возврат на работу', desc: 'Рутина затягивает, новые навыки отходят на второй план' },
    { label: 'Всё забыли через неделю', desc: 'Без практики и контроля информация теряется на 70%' },
    { label: 'Никаких изменений', desc: 'KPI не растут, деньги потрачены впустую' },
  ];

  const goodModel = [
    { label: 'Диагностика', desc: 'Анализ текущих KPI, аудит компетенций, выявление точек роста' },
    { label: 'Адаптация программы', desc: 'Индивидуальная программа под задачи, отрасль и уровень команды' },
    { label: 'Практика', desc: '80% времени — отработка на реальных кейсах компании' },
    { label: 'Внедрение', desc: 'Домашние задания, чек-листы, интеграция в ежедневную работу' },
    { label: 'Сопровождение', desc: 'Посттренинговые встречи, контроль выполнения, корректировка' },
    { label: 'Рост KPI', desc: 'Измеримые результаты: конверсия, средний чек, повторные продажи' },
  ];

  return (
    <section className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-3xl md:text-5xl font-bold text-gray-900 text-center mb-6">
          Почему большинство корпоративных обучений не дают результата
        </h2>
        <p className="text-lg text-gray-600 text-center mb-16 max-w-3xl mx-auto">
          Проблема не в обучении как таковом — проблема в подходе. Посмотрите на разницу.
        </p>

        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 max-w-5xl mx-auto">
          {/* Стандартная модель */}
          <div className="bg-white rounded-2xl p-8 border-2 border-red-100">
            <div className="flex items-center gap-3 mb-8">
              <div className="w-10 h-10 bg-red-100 rounded-full flex items-center justify-center">
                <i className="ri-close-circle-line text-xl text-red-500"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900">Стандартная модель</h3>
            </div>

            <div className="space-y-0">
              {badModel.map((step, i) => (
                <div key={i} className="flex gap-4">
                  <div className="flex flex-col items-center">
                    <div className="w-10 h-10 bg-red-100 rounded-full flex items-center justify-center flex-shrink-0">
                      <span className="text-sm font-bold text-red-500">{i + 1}</span>
                    </div>
                    {i < badModel.length - 1 && (
                      <div className="w-0.5 h-8 bg-red-200"></div>
                    )}
                  </div>
                  <div className="pb-6">
                    <h4 className="font-semibold text-gray-900 text-sm mb-1">{step.label}</h4>
                    <p className="text-gray-500 text-xs leading-relaxed">{step.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Авторская система */}
          <div className="bg-white rounded-2xl p-8 border-2 border-teal-100">
            <div className="flex items-center gap-3 mb-8">
              <div className="w-10 h-10 bg-teal-100 rounded-full flex items-center justify-center">
                <i className="ri-check-double-line text-xl text-teal-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900">Авторская система</h3>
            </div>

            <div className="space-y-0">
              {goodModel.map((step, i) => (
                <div key={i} className="flex gap-4">
                  <div className="flex flex-col items-center">
                    <div className="w-10 h-10 bg-teal-100 rounded-full flex items-center justify-center flex-shrink-0">
                      <span className="text-sm font-bold text-teal-600">{i + 1}</span>
                    </div>
                    {i < goodModel.length - 1 && (
                      <div className="w-0.5 h-8 bg-teal-200"></div>
                    )}
                  </div>
                  <div className="pb-6">
                    <h4 className="font-semibold text-gray-900 text-sm mb-1">{step.label}</h4>
                    <p className="text-gray-500 text-xs leading-relaxed">{step.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* CTA между блоками */}
        <div className="mt-12 text-center">
          <button
            onClick={() => scrollTo('contact')}
            className="bg-teal-600 text-white px-8 py-4 rounded-lg text-base font-semibold hover:bg-teal-700 transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
          >
            Получить программу обучения
            <i className="ri-arrow-right-line"></i>
          </button>
        </div>
      </div>
    </section>
  );
}